import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';

export default class BackOfANapkinTemplatesCustomerValuesDropdownComponent extends Component {
  @service organisation;
  @service intl;
  @tracked customerValueFormIsVisible = false;
  tippyInstance = null;

  get customerValues() {
    return this.organisation.customer_values_options;
  }

  get labelKey() {
    return this.args.labelKey;
  }

  @action
  handleCustomerValueSelect(e) {
    if (e.key === 'custom') {
      this.customerValueFormIsVisible = true;
      this.tippyInstance.hide();
      return;
    }
    this.args?.onSelect(e);
    this.tippyInstance.hide();
  }

  @action
  closeForm() {
    this.customerValueFormIsVisible = false;
  }

  @action
  onCreate(e) {
    this.tippyInstance = e;
  }

  get customerValueLabel() {
    if (!this.labelKey) return this.intl.t(`financials.customer-values.custom`);
    return this.intl.t(
      `financials.customer-values.${this.labelKey.toLowerCase()}`,
    );
  }

  @action
  propogateCustomValue(customer_value) {
    const customer_value_object = {
      key: 'custom',
      label: this.intl.t('financials.customer-values.custom'),
      value: customer_value,
    };
    this.args?.onSelect(customer_value_object);
    this.closeForm();
  }
}
